export default __webpack_public_path__ + "static/media/4.4f4da2bf.jpg";